import {
  Autocomplete, Box, Dialog, IconButton, Skeleton, Tab,
  Table, TableBody, TableCell, TableHead, TableRow, TextField,
  Tooltip, Typography
} from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import ShowComponents from '../../DoctorNotes/Common/ShowComponent'
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PrintIcon from '@mui/icons-material/Print';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import {
  AXIS_OPTIONS, BCDVA_OPTIONS, COMMON_STYLE,
  CYL_OPTIONS, LENS_TYPE_OPTIONS, SPH_OPTIONS, UMA_FRAME_TYPE, ADD
} from '../../../../Utility/Constants';
import RestAPIService from '../../../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import CloseIcon from '@mui/icons-material/Close';

const UmaDocPrevGlassPower = React.forwardRef((props, ref) => {
  const [glassPower, setGlassPower] = useState({
    selectedDate: new Date(),
    openDate: false,
    frameTypeList: UMA_FRAME_TYPE,
    selectedFrameType: '',
    lensTypeList: LENS_TYPE_OPTIONS,
    selectedLensType: '',
    SPHList: SPH_OPTIONS,
    CYLList: CYL_OPTIONS,
    AXISList: AXIS_OPTIONS,
    BCDVAList: BCDVA_OPTIONS,
    ADDList: ADD,
    glassComments: '',
    glassPowerData: [],
    prevGlassPowerData: [],
    printLoad: false,
    openComparePopup: false,
    prevSelectedFrameType: '',
    prevGlassComments: '',
    prevSelectedLensType: '',
    glassPowerDate: null,
    prevGlassPowerDate: null,
    loadScreen: false,
    enableCompare: false,
    enableCopy: false,
    dupGlassPowerData: '[]',
    dupSelectedFrameType: '',
    dupSelectedLensType: '',
    dupGlassComments: '',
    dupSelectedDate: ''
  })
  const changedRef = useRef(false)
  const [inputValues, setInputValues] = useState({})
  const [message, setMessage] = useState({
    isErrorMsgText: '',
    successMsgText: '',
    isErrorMsg: false,
    successMsg: false,
  })
const [frameTypeInput, setFrameTypeInput] = React.useState("")
const [lensTypeInput, setLensTypeInput] = React.useState("")

  const errorMessage = (message) => {
    setMessage({
      ...message,
      isErrorMsg: true,
      isErrorMsgText: `${message} - PREVIOUS GLASS POWER`,
    })
  }

  const successMessage = (message) => {
    setMessage({
      ...message,
      successMsg: true,
      successMsgText: `${message} - PREVIOUS GLASS POWER`,
    })
  }

  const msgClose = () => {
    setMessage({
      ...message,
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  React.useImperativeHandle(ref, () => ({
    performPrevGlassPowerAction: () => {
      if (
        (JSON.stringify(glassPower.glassPowerData) !== glassPower.dupGlassPowerData) || JSON.stringify(glassPower.selectedFrameType) !== glassPower.dupSelectedFrameType ||
        JSON.stringify(glassPower.selectedLensType) !== glassPower.dupSelectedLensType || (JSON.stringify(glassPower.glassComments) !== glassPower.dupGlassComments)
      ) {
        postPrevGlassPowerData()
      }
    }
  }))

  const apiCalls = async () => {
    await getPrevGlassPowerData()
    await getPrevGlassPowerCopyData()
  }

  useEffect(() => {
    if (glassPower.printLoad) {
      getPrevGlassPowerPrint()
    }
    if (glassPower.glassPowerData && glassPower.prevGlassPowerData) {
      let compare = Array.isArray(glassPower.glassPowerData) && glassPower.glassPowerData?.some(item => ((item?.SPH) || (item?.CYL) || (item?.AXIS) || (item?.BCDVA) || (item?.add)));
      let copy = Array.isArray(glassPower.prevGlassPowerData) && glassPower.prevGlassPowerData?.some(item => ((item?.SPH) || (item?.CYL) || (item?.AXIS) || (item?.BCDVA)|| (item?.add)));
      setGlassPower((prev) => ({
        ...prev,
        enableCopy: !copy,
        enableCompare: compare
      }))
    }
  }, [glassPower.printLoad, glassPower.glassPowerData, glassPower.prevGlassPowerData])
  const getPrevGlassPowerData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PREV_GLASS_POWER + '?appointment_id=' + props?.props?.appointment_id + '&doctor_id=' + props?.props?.doctorID)
      if (response?.data?.status === 'success') {
        let emptyArray = [
          { eye_type: 'RE', SPH: "", CYL: "", AXIS: "", BCDVA: "", BCNVA: "", add: "" },
          { eye_type: "LE", SPH: "", CYL: "", AXIS: "", BCDVA: "", BCNVA: "", add: "" }
        ]
        let prevData = Object.keys(response?.data?.data)?.length > 0 ? response?.data?.data : {}
        setGlassPower((prev) => ({
          ...prev,
          glassPowerData: Object.keys(prevData)?.length > 0 ? prevData?.pgp : emptyArray,
          glassPowerDate: Object.keys(prevData)?.length > 0 ? prevData?.date : null,
          selectedDate: new Date(),
          selectedFrameType: Object.keys(prevData)?.length > 0 ? prevData?.frame_type : '',
          glassComments: Object.keys(prevData)?.length > 0 ? prevData?.comment : '',
          selectedLensType: Object.keys(prevData)?.length > 0 ? prevData?.lens_type : '',
          dupSelectedLensType: Object.keys(prevData)?.length > 0 ? JSON.stringify(prevData?.lens_type) : JSON.stringify(''),
          dupGlassPowerData: Object.keys(prevData)?.length > 0 ? JSON.stringify(prevData?.pgp) : JSON.stringify(emptyArray),
          dupSelectedFrameType: Object.keys(prevData)?.length > 0 ? JSON.stringify(prevData?.frame_type) : JSON.stringify(''),
          dupGlassComments: Object.keys(prevData)?.length > 0 ? JSON.stringify(prevData?.comment) : JSON.stringify(''),
          dupSelectedDate: JSON.stringify(new Date()),
          loadScreen: true
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevGlassPowerPrint = async () => {
    try {
      const response = await RestAPIService.getAllPrint(Serviceurls.NEW_DOC_NOTES_PREV_GLASS_POWER +
        '?appointment_id=' + props?.props?.appointment_id + '&export_type=pdf' + '&doctor_id=' + props?.props?.doctorID
      )
      if (response) {
        const file = new Blob(
          [response.data],
          { type: 'application/pdf' });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL);
        setGlassPower((prev) => ({ ...prev, printLoad: false }))
      }
    } catch (error) {
      setGlassPower((prev) => ({ ...prev, printLoad: false }))
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const postPrevGlassPowerData = async () => {
    try {
      let startDate = new Date(glassPower.selectedDate)
      let selectedDate = DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')
      let data = {
        appointment_id: props?.props?.appointment_id,
        date: selectedDate,
        comment: glassPower.glassComments ? glassPower.glassComments : '',
        frame_type: glassPower.selectedFrameType ? glassPower.selectedFrameType : '',
        lens_type: glassPower.selectedLensType ? glassPower.selectedLensType : '',
        pgp: glassPower.glassPowerData
      }
      const response = await RestAPIService.create(data, Serviceurls.NEW_DOC_NOTES_PREV_GLASS_POWER)
      if (response?.data?.status === 'success') {
        successMessage(response?.data?.message)
        await getPrevGlassPowerData()
        changedRef.current = false
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const getPrevGlassPowerCopyData = async () => {
    try {
      const response = await RestAPIService.getAll(Serviceurls.NEW_DOC_NOTES_PREV_GLASS_POWER_COPY +
        '?appointment_id=' + props?.props?.appointment_id + '&patient_id=' + props?.props?.patient_id + '&doctor_id=' + props?.props?.doctorID
      )
      if (response.data.status === 'success') {
        let prevData = Object.keys(response.data?.data)?.length > 0 ? response?.data?.data : {}
        setGlassPower((prev) => ({
          ...prev,
          prevGlassPowerData: Object.keys(prevData)?.length > 0 ? prevData?.pgp : [],
          prevGlassComments: Object.keys(prevData)?.length > 0 ? prevData?.comment : '',
          prevSelectedFrameType: Object.keys(prevData)?.length > 0 ? prevData?.frame_type : '',
          prevSelectedLensType: Object.keys(prevData)?.length > 0 ? prevData?.lens_type : '',
          prevGlassPowerDate: Object.keys(prevData)?.length > 0 ? prevData?.date : ''
        }))
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        errorMessage(error.response?.data?.message)
      } else {
        errorMessage(error.message)
      }
    }
  }

  const autocompleteTextBox = (names, values, options = [], optionLabel, placeholders, index) => {
    try {
      const fieldKey = `${names}_${index}`;
      const handleStrictMatch = (inputValue) => {
        const matchedOption = options.find(
          (opt) => {
            const optionText =
              typeof opt === "string" ? opt : opt[optionLabel];

            return optionText?.toLowerCase() === inputValue?.toLowerCase();
          }
        );

        let glassPowerData = [...glassPower.glassPowerData];

        glassPowerData[index] = {
          ...glassPowerData[index],
          [names]: matchedOption ? matchedOption[optionLabel] : ""
        };

        setGlassPower((prev) => ({ ...prev, glassPowerData }));
        changedRef.current = true;

        setInputValues((prev) => ({
          ...prev,
          [fieldKey]: matchedOption ? matchedOption[optionLabel] : ""
        }));
      };


      return (
        <Autocomplete
          disabled={props?.props?.patient_transfered || props?.props?.isLocked}
          clearIcon
          size='small'
          sx={{ width: '6dvw' }}
          value={values || null}
          options={options}
          inputValue={inputValues[fieldKey] ?? values ?? ""}
          getOptionLabel={(option) => typeof (option) === 'string' ? option : option[optionLabel] || ""}
          onChange={(e, newValue) => {
            let glassPowerData = [...glassPower.glassPowerData]
            glassPowerData[index] = { ...glassPowerData[index], [names]: newValue ? newValue[optionLabel] || "" : "" }
            setGlassPower((prev) => ({ ...prev, glassPowerData: glassPowerData }))
            changedRef.current = true
            setInputValues((prev) => ({
              ...prev,
              [fieldKey]: newValue ? newValue[optionLabel] : ""
            }));
          }}
          onInputChange={(e, newInputValue) => {
            setInputValues((prev) => ({
              ...prev,
              [fieldKey]: newInputValue
            }));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder={placeholders}
              onBlur={(e) => handleStrictMatch(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  handleStrictMatch(e.target.value);
                }
              }}
              InputProps={{
                ...params.InputProps, emed_tid: names,
                style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
              }}
            />
          )}
        />
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderGlassPowerTable = () => {
    try {
      return (
        <Box component={'div'} border={'1px solid lightgray'}>
          <Table size='small'>
            <TableHead>
              <TableRow>
                <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {glassPower?.glassPowerData?.map((item, index) => {
                return (
                  <TableRow key={index}>
                    <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('SPH', item?.SPH, glassPower?.SPHList, 'label', 'SPH', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('CYL', item?.CYL, glassPower?.CYLList, 'label', 'CYL', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('AXIS', item?.AXIS, glassPower?.AXISList, 'label', 'AXIS', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('BCDVA', item?.BCDVA, glassPower?.BCDVAList, 'label', 'BCDVA', index)}
                    </TableCell>
                    <TableCell className='doc_notes_tbl_body_cell'>
                      {autocompleteTextBox('add', item?.add, glassPower?.ADDList, 'label', 'ADD', index)}
                    </TableCell>
                  </TableRow>
                )
              })}
            </TableBody>
          </Table>
        </Box>
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  const renderComparePopup = () => {
    try {
      return (
        <Dialog open={glassPower.openComparePopup} maxWidth="md" fullWidth>
          <Box className='doc_addendum_popup'>
            <Box component={'div'} p={'0.2rem 0.5rem'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} borderBottom={'2px solid lightgray'}>
              <Typography className='doc_notes_header_card_font'>Compare Previous Glass Power</Typography>
              <IconButton emed_tid='cmp_prev_cls'
                onClick={() => setGlassPower((prev) => ({ ...prev, openComparePopup: false }))}><CloseIcon /></IconButton>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Box component={'div'} display={'flex'} alignItems={'center'}>
                <Typography className='doc_notes_header_card_font'>Current Glass Power</Typography>
                <Tooltip placement='top' arrow title={'Copy'}>
                  <IconButton className='Common_Btn_Min_Width' sx={{ height: '3dvh' }} emed_tid='prev_cmp_cpy'
                    onClick={() => {
                      setGlassPower((prev) => ({
                        ...prev,
                        glassPowerData: glassPower.prevGlassPowerData,
                        glassComments: glassPower.prevGlassComments,
                        selectedFrameType: glassPower.prevSelectedFrameType,
                        selectedLensType: glassPower.prevSelectedLensType,
                        glassPowerDate: glassPower.prevGlassPowerDate,
                        openComparePopup: false
                      }))
                      changedRef.current = true
                    }}
                  ><ContentCopyIcon color={'primary'} /></IconButton></Tooltip>
              </Box>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {glassPower.prevGlassPowerData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.SPH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.CYL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.AXIS}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.BCDVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.add}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
            <Box component={'div'} p={'0.5rem'}>
              <Typography className='doc_notes_header_card_font'>New Glass Power</Typography>
              <Box component={'div'} border={'1px solid lightgray'} mt={'0.5rem'}>
                <Table size='small'>
                  <TableHead>
                    <TableRow>
                      <TableCell className='doc_notes_tbl_header'>Eye</TableCell>
                      <TableCell className='doc_notes_tbl_header'>SPH</TableCell>
                      <TableCell className='doc_notes_tbl_header'>CYL</TableCell>
                      <TableCell className='doc_notes_tbl_header'>AXIS</TableCell>
                      <TableCell className='doc_notes_tbl_header'>BCDVA</TableCell>
                      <TableCell className='doc_notes_tbl_header'>ADD</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {glassPower.glassPowerData?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.eye_type}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.SPH}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.CYL}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.AXIS}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.BCDVA}</TableCell>
                          <TableCell className='doc_notes_tbl_body_cell doc_notes_header_card_font'>{item?.add}</TableCell>
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </Box>
            </Box>
          </Box>
        </Dialog >
      )
    } catch (error) {
      errorMessage(error.message)
    }
  }

  return (
    <ShowComponents onIntersection={apiCalls}>
      <Box component={'div'}>
        <Box component={'div'}>
          <Box component={'div'} className='doc_notes_header_card' display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
            <Typography className='doc_notes_header_card_font'>Previous Glass Power</Typography>
            <Box component={'div'} display={'flex'} alignItems={'center'}>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  open={glassPower.openDate}
                  onOpen={() => setGlassPower((prev) => ({ ...prev, openDate: true }))}
                  onClose={() => setGlassPower((prev) => ({ ...prev, openDate: false }))}
                  value={glassPower.selectedDate}
                  inputFormat="DD-MM-YYYY"
                  maxDate={DateTime.now()}
                  onChange={(newDate) => { setGlassPower((prev) => ({ ...prev, selectedDate: newDate })) }}
                  renderInput={(params) => <TextField sx={{ width: '10dvw' }} onKeyDown={(e) => e.preventDefault()}
                    {...params}
                    InputProps={{ ...params.InputProps, style: { height: '4dvh' } }}
                    onClick={() => setGlassPower((prev) => ({ ...prev, openDate: true }))}
                  />}
                />
              </LocalizationProvider>
              <Tooltip placement='top' arrow title={'Print'}>
                <IconButton className='Common_Btn_Min_Width' emed_tid='prev_gls_prt'
                  disabled={glassPower.printLoad}
                  onClick={() => setGlassPower((prev) => ({ ...prev, printLoad: true }))}
                ><PrintIcon color='primary' /></IconButton></Tooltip>
              <Tooltip placement='top' arrow title={'Copy'}>
                <IconButton className='Common_Btn_Min_Width' emed_tid='prev_gls_cpy'
                  disabled={glassPower?.enableCopy || props?.props?.patient_transfered || props?.props?.isLocked}
                  onClick={() => {
                    setGlassPower((prev) => ({
                      ...prev,
                      glassPowerData: glassPower.prevGlassPowerData,
                      glassComments: glassPower.prevGlassComments,
                      selectedFrameType: glassPower.prevSelectedFrameType,
                      selectedLensType: glassPower.prevSelectedLensType
                    }))
                    changedRef.current = true
                  }}
                ><ContentCopyIcon color={glassPower.enableCopy ? 'disabled' : 'primary'} /></IconButton></Tooltip>
              <Tooltip placement='top' arrow title={'View'}>
                <IconButton className='Common_Btn_Min_Width' emed_tid='prev_gls_vis'
                  disabled={!(glassPower.enableCompare && !glassPower.enableCopy) || props?.props?.patient_transfered || props?.props?.isLocked}
                  onClick={() => setGlassPower((prev) => ({ ...prev, openComparePopup: true }))}
                ><VisibilityIcon color={!(glassPower.enableCompare && !glassPower.enableCopy) ? 'disabled' : 'primary'} /></IconButton></Tooltip>
            </Box>
          </Box>
          <Box component={'div'} m={'0.5rem'}>
            <Box component={'div'} display={'flex'}>
              <Autocomplete
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                clearIcon
                size='small'
                sx={{ width: '13dvw', mr: '0.5rem' }}
                inputValue={frameTypeInput} 
                value={glassPower.selectedFrameType}
                options={glassPower.frameTypeList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                onChange={(e, newValue) => {
                setGlassPower((prev) => ({ ...prev, selectedFrameType: newValue?.value }))
                  setFrameTypeInput(newValue?.label || "")
                }}
                onInputChange={(e, newValue) => {    
                  setFrameTypeInput(newValue)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder='Select Frame Type'
                    onBlur={(e) => {
                      const typedValue = e.target.value?.toLowerCase();

                      const match = glassPower.frameTypeList.find(
                        (o) => o.label.toLowerCase() === typedValue
                      );

                      if (match) {
                        setGlassPower((p) => ({
                          ...p,
                          selectedFrameType: match.value
                        }));
                        setFrameTypeInput(match.label);
                      } else {
                        setGlassPower((p) => ({ ...p, selectedFrameType: "" }));
                        setFrameTypeInput("");
                      }
                    }}
                    onKeyDown={(e) => {                   
                      if (e.key === "Enter") e.target.blur();
                    }}

                    InputProps={{
                      ...params.InputProps, emed_tid: 'prev_gls_frme',
                      style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                  />
                )}
              />
              <Autocomplete
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                clearIcon
                size='small'
                sx={{ width: '13dvw', mr: '0.5rem' }}
                inputValue={lensTypeInput}  

                value={glassPower.selectedLensType}
                options={glassPower.lensTypeList}
                getOptionLabel={(option) => typeof (option) === 'string' ? option : option?.label}
                onChange={(e, newValue) => {
                  setGlassPower((prev) => ({ ...prev, selectedLensType: newValue?.label }))
                  setLensTypeInput(newValue?.label || "")    
                }}
                onInputChange={(e, newValue) => {            
                  setLensTypeInput(newValue)
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder='Select Lens Type'

                    onBlur={(e) => {
                      const typedValue = e.target.value?.toLowerCase();

                      const match = glassPower.lensTypeList.find(
                        (o) => o.label.toLowerCase() === typedValue
                      );

                      if (match) {
                        setGlassPower((p) => ({
                          ...p,
                          selectedLensType: match.label
                        }));
                        setLensTypeInput(match.label);
                      } else {
                        setGlassPower((p) => ({ ...p, selectedLensType: "" }));
                        setLensTypeInput("");
                      }
                    }}
                    onKeyDown={(e) => {                   
                      if (e.key === "Enter") e.target.blur();
                    }}

                    InputProps={{
                      ...params.InputProps, emed_tid: 'prev_gls_lns',
                      style: { height: COMMON_STYLE.HEIGHT, padding: COMMON_STYLE.PADDING }
                    }}
                  />
                )}
              />
              {glassPower.glassPowerDate ?
                <Box component={'div'} display={'flex'} alignItems={'center'}>
                  <Typography className='doc_notes_header_card_font'>{`Date : ${glassPower.glassPowerDate}`}</Typography>
                </Box> : null}
            </Box>
            <Box component={'div'} m={'0.5rem 0rem'}>
              {renderGlassPowerTable()}
            </Box>
            <Box component={'div'}>
              <TextField
                disabled={props?.props?.patient_transfered || props?.props?.isLocked}
                size='small'
                multiline
                fullWidth
                maxRows={5}
                value={glassPower.glassComments}
                onChange={(e) => {
                  let value = e.target.value
                  if (value?.length <= 1000) {
                    setGlassPower({ ...glassPower, glassComments: value })
                  }
                }}
                placeholder='Comments'
                inputProps={{ emed_tid: 'prev_gls_cmts', maxLength: COMMON_STYLE.CHAR_LIMIT_DESP }}
              />
            </Box>
          </Box>
        </Box>
        {renderComparePopup()}
        {message.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={message.isErrorMsgText}
            msgPop={msgClose}
          />
          : null}
        {message.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={message.successMsgText}
            msgPop={msgClose}
          />
          : null}
      </Box>
    </ShowComponents>
  )
})

export default UmaDocPrevGlassPower